export default "__VITE_ASSET__MiCsx_xG__"